import { useActions } from 'components/shared/hooks/useActions';
import { AssistantAiActions } from '../actions';

export const useAssistantAiActions = () => {
  const actions = useActions(AssistantAiActions);

  return {
    ...actions,
  };
};
